import type { ReactNode } from 'react';

export const relatedLinks: Array<{
  icon: ReactNode;
  title: string;
  link: string;
}> = [];
